module.exports = __webpack_public_path__ + "static/img/restaurant.d2cb2011.svg";